export namespace tree{
    export interface Person {
        name: string;
        firstName: string;
        erreur:"nom"|"prenom"|null
      }//

      export interface person{
        name: string;
        firstName: string;
      }
      export interface FamilyRow {
        //  lastGen:number,
          paternel:FamilyRow|null,
          maternel:FamilyRow|null,
        //  voirPastGen:boolean,
          man: person;
          woman: person;
          city: string;
          province: string; 
          date: string;
       
        }

    export interface FamilyGen {
        //  lastGen:number,
          paternel:FamilyGen|null,
          maternel:FamilyGen|null,
        //  voirPastGen:boolean,
          man: Person;
          woman: Person;
          city: string;
          province: string; 
          date: string;
          erreur:"ville"|"date"|"person"|"erreur"|"empty"|null
        }



    export interface geneo{
        owner:Person,
        parents:FamilyGen,
        
    }

    export interface Address {
        province: string;
        city: string;
        postalCode: string;
        streetAddress: string;
      
   
      }

      export function emptyAddr(): Address {
        return {
          province: "Québec",
          city: "",
          postalCode: "",
          streetAddress: "",
          //nom: "",
          //mail: "",
         // prenom: "",
         
        };
      }

    export interface arbre{
        owner:person,
        family:FamilyRow,
        addr:Address
       // addr:Address
    }

    function convertPerson(p:Person):person{
        try{
            const {name,firstName}=p
            return {name,firstName}
        }catch(error)
        {
            console.log(error)
            debugger;
            throw error
        }
    }

    function convertGen(gen:FamilyGen|null):FamilyRow|null
    {
        try{
            if(gen===null)
                return null
            const {paternel,
                maternel,
                    man,
                woman,
                city,
                province,
                date}=gen
            return {
                paternel:convertGen(paternel),
                maternel:convertGen(maternel),
                    man:convertPerson(man),
                woman:convertPerson(woman),
                city,
                province,
                date
            }
        }catch(error)
        {
            console.log(error)
            debugger;
            throw error
        }
    }

    export function convert(gen:geneo,addr:Address):arbre
    {
        try{
            const parents=convertGen(gen.parents)
            if(!parents)
                throw "no parents"
            return {
                owner:convertPerson(gen.owner),
                family:parents,
                addr
            }
        }catch(error)
        {
            console.log(error)
            debugger;
            throw error
        }
    }

    export function emptyPerson():Person
    {
        return {
            name:"",
            firstName:"",
            erreur:null
        }
    }

    export function emptyFam(p:{paternel:FamilyGen|null,maternel:FamilyGen|null}):FamilyGen
    {
        return {
            paternel:p.paternel,
            maternel:p.maternel,
            man: emptyPerson(),
            woman: emptyPerson(),
            city: "",
          //  voirPastGen:false,
            province: "Québec",
            date: "",
            erreur:"empty"
        }
    }

    export function emptyTree():geneo
    {
        return {
            owner:emptyPerson(),
            parents:emptyFam({
                                paternel:emptyFam({paternel:null,maternel:null}),
                                maternel:emptyFam({paternel:null,maternel:null}),
                               
                            })
        }
    }
}